import { resolveCallToAction } from 'utils/helpers'
import { humanizeCallToAction } from './format'

const isYoutubeMedia = (media) => Boolean(media?.youtube_video_id)

function toCarouselCard(card) {
  return {
    id: card?.media?.id,
    media: card?.media,
    headline: card?.headline,
    url: card?.url,
  }
}

export function getCarouselAdVariations(creative, t) {
  // Meta only ever accepts a real uploaded video file in a carousel card,
  // never a YouTube passthrough — drop any card whose media is
  // YouTube-typed before building variations, same reasoning as
  // metaSingleImageVariations.js's indexedMediaByShape.
  const cards = (creative?.carousel_cards ?? []).filter((card) => !isYoutubeMedia(card?.media))
  if (!cards.length) return []

  const bodies = (creative?.body ?? []).filter(Boolean)
  const destinationUrls = (creative?.destination_url ?? []).filter(Boolean)
  const carouselCards = cards.map(toCarouselCard)
  const callToAction = humanizeCallToAction(resolveCallToAction(creative?.call_to_action, 'fb'), t)

  const ads = []
  bodies.forEach((body, bodyIdx) => {
    destinationUrls.forEach((destinationUrl, urlIdx) => {
      ads.push({
        pageName: creative?.page_name ?? null,
        profilePictureUrl: creative?.profile_picture_url ?? null,
        body,
        callToAction,
        carouselCards,
        variationId: `1${bodyIdx + 1}1${urlIdx + 1}`,
      })
    })
  })
  return ads
}
